module.exports = __webpack_public_path__ + "static/media/grapes.61e7242d.png";